<template>
  <div class="_plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <!-- <img src="https://www.7859888tp.com/750-50.gif" /> -->
    </div>
    <p class="plan_item_title">
      <span class="blink2 fs4"> 【彩霸王】 天地必中</span>
    </p>
    <ul>
      <li v-for="(el, i) in data.list" :key="i" :class="{ li_win: el.ifWin }">
        <div class="qi fs4">
          {{ el.qiShu }}期 【天地必中】
          <span class="winText" v-if="el.ifZuiXin">等开</span>
          <span class="winText" v-else
            >开：{{ getNumSx(el.code, el.qiShu) }} {{ el.code
            }}{{ el.ifWin ? "准" : "错" }}</span
          >
        </div>
        <div class="value">
          <div>
            <span class="color2">
              【
              <span
                :class="`fs4 ${
                  el.shuXingList ? (el.shuXingList[0].ifWin ? 'win' : '') : ''
                }`"
                >{{ el.yuCe[0] }}</span
              >
              】
            </span>
            <span>主三肖</span>
            <span
              :class="`color2 ${
                el.shuXingList &&
                !el.shuXingList[1].ifWin &&
                !el.shuXingList[2].ifWin &&
                !el.shuXingList[3].ifWin
                  ? 'suck'
                  : ''
              }`"
            >
              【
              <span
                :class="`fs4 ${
                  el.shuXingList ? (el.shuXingList[1].ifWin ? 'win' : '') : ''
                }`"
                >{{ el.yuCe[1] }}</span
              >
              <span
                :class="`fs4 ${
                  el.shuXingList ? (el.shuXingList[2].ifWin ? 'win' : '') : ''
                }`"
                >{{ el.yuCe[2] }}</span
              >
              <span
                :class="`fs4 ${
                  el.shuXingList ? (el.shuXingList[3].ifWin ? 'win' : '') : ''
                }`"
                >{{ el.yuCe[3] }}</span
              >
              】
            </span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
      
      <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";
import { getNumSx } from "@/utils";

function jsonp(data) {
  return JSON.parse(data);
}

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);
</script>
      
      <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
._plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    background: #3e73fe;
    padding: 16px 0;
    line-height: 16px;
    color: #fff !important;
    border-radius: 12px 12px 0 0;
  }
  ul {
    background-color: #eee;
    margin-top: -12px;
    border-radius: 12px;
    overflow: hidden;
    li {
      text-align: center;
      padding: 5px 30px;
      font-weight: bold;
      .value {
        .win {
          background-color: #ffff00;
          color: red;
        }
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
    }
    .li_win {
      .winText {
        color: #309631;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
.tip {
  text-align: center;
  margin: 8px 0;
  font-weight: bold;
  display: flex;
  justify-content: space-around;
}
</style>